module.exports = __webpack_public_path__ + "static/12-d83b789434b0f8d05f78fd776e407d6a.png";